module.exports = __webpack_public_path__ + "static/media/spray-can.d6272a37.svg";